/**
 * <random-promo>
 *
 * Picks ONE random <template> child and clones it into the DOM on connect.
 * Collection pages are full-page cached by Shopify, so the server-rendered markup
 * is identical for every visitor until the cache expires. Rendering every valid
 * banner as an inert <template> (templates do not download media) and choosing one
 * client-side keeps the randomisation per page load while downloading a single asset.
 *
 * The element MUST stay display:contents (set inline in Liquid) so the cloned promo
 * card remains a direct grid item of the product list.
 */
if (!customElements.get('random-promo')) {
  customElements.define(
    'random-promo',
    class RandomPromo extends HTMLElement {
      connectedCallback() {
        if (this.dataset.rendered) return;

        const templates = this.querySelectorAll(':scope > template');
        if (!templates.length) return;

        const chosen = templates[Math.floor(Math.random() * templates.length)];
        const fragment = chosen.content.cloneNode(true);

        // Exactly one banner is rendered, so its media should load immediately. A
        // lazy <img> cloned from an inert <template> does not reliably trigger the
        // browser's lazy-load observer, so promote the chosen media to eager.
        fragment.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.setAttribute('loading', 'eager');
        });

        this.appendChild(fragment);
        this.dataset.rendered = 'true';
      }
    }
  );
}
